import ownerDocument from './ownerDocument';
export default function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/utils/ownerWindow.js
// module id = 464
// module chunks = 121